import { Comment, CommentsItem, useComments } from 'features/comments';

interface ListProps {
  comments: CommentsItem[];
  level?: number;
}

const List = ({ comments, level = 0 }: ListProps) => {
  const { replyingCommentUuid } = useComments();

  return (
    <>
      {comments.map((comment) => (
        <Comment key={`comment-${comment.uuid}`} comment={comment} replying={replyingCommentUuid === comment.uuid} level={level} />
      ))}
    </>
  );
};

export default List;
